import * as React from 'react'
import { withFormik } from 'formik'
import { get } from 'lodash'
import '../../../Quote/styles/Step04.css'
import { MarkerIcon } from '../../../../../images/icons/Marker/Marker'
import { Button } from '../../../../common/Button/Button'
import ReactSwitch from '../../../../common/ReactSwitch/ReactSwitch'
import { currency, symbol } from '../../../../common/CurrencyFormat'
let locBtndisable: any = false
class Step04cFormHTML extends React.Component<any, any> {
    constructor(props: any) {
        super(props)

        this.state = {
            method: false,
            sumAllocated: 0,
            allocated: [],
            al_disable: false,
        }
    }
    componentDidUpdate(preprops: any) {
        if (preprops.values.riskLocations !== this.props.values.riskLocations) {
            let points: any = []
            if (this.props.values.riskLocations && this.props.values.riskLocations.length === 1
                && this.state.sumAllocated === 0) {
                let sumPrints: any =
                    this._calculateSum(this.props.values.agreedItems, this.props.values.unspecifiedItems)
                Object.values(this.props.values.riskLocations).map((al: any, index) => {
                    al.allocated = 100
                    points.push(al.allocated)
                })
                this.setState({ allocated: points, sumAllocated: (100 / 100) * sumPrints })
            }
            if (this.props.values.riskLocations && this.props.values.riskLocations.length > 1 &&
                this.state.sumAllocated !== 0) {
                Object.values(this.props.values.riskLocations).map((al: any, index) => {
                    al.allocated = 0
                    points.push(al.allocated)
                })
                this.setState({ allocated: points, sumAllocated: 0 })
            }
        }
        // if (this.props.checkStep03update && this.props.values.riskLocations &&
        //     this.props.values.riskLocations.length > 1 &&
        //     this.state.sumAllocated === 0) {
        //     let points: any = []
        //     Object.values(this.props.values.riskLocations).map((al: any, index) => {
        //         al.allocated = 0
        //         points.push(al.allocated)
        //     })
        //     this.setState({ allocated: points, sumAllocated: 0, checkStep03update: false })
        // }
    }

    _calculateSum = (agreedItems, unspecifiedItems) => {
        let total = 0
        if (agreedItems && Object.values(agreedItems).length) {
            Object.values(agreedItems).map((agreedType) => {
                Object.values(agreedType).map((s) => {
                    total += parseFloat(s.insured)
                })
            })
        }
        if (unspecifiedItems && Object.values(unspecifiedItems).length) {
            Object.values(unspecifiedItems).map((u: any) => {
                total += parseFloat(u)
            })
        }
        // return Number(total).toFixed(2)
        return Number(total)
    }

    changeMethod = (val) => {
        this.setState({
            method: val,
        })
        let amt: any = 0
        const {
            values,
        } = this.props
        let points: any = []
        let sumPrints: any = this._calculateSum(values.agreedItems, values.unspecifiedItems)
        Object.values(this.state.allocated).map((al: any) => {
            if (this.state.method === true) {
                amt = (al / sumPrints) * 100
            } else {
                amt = (al / 100) * sumPrints
            }
            points.push(amt)
        })
        this.setState({ allocated: points })
    }

    handleDynamicValueChange: any = (id, val, sumPrints, event) => {
        let points: any = []
        let amt = 0
        let evntValue = 0
        // let points: any = []
        let sumAllocated = 0
        evntValue = event.target.value
        const {
            values,
        } = this.props

        if (Object.values(values.riskLocations).length) {
            Object.values(values.riskLocations).map((al: any, index) => {
                al.allocated = this.state.allocated[index]
            })
        }

        if (Object.values(val).length) {
            Object.values(val).map((al: any, index) => {
                if (al.id === id) {
                    al.allocated = evntValue
                }
                let all = al.allocated
                if (all === '' || all === undefined || all === null) {
                    all = 0
                }
                points.push(all)
                amt += parseFloat(all)
            })
        }

        this.setState({ allocated: points })

        if (this.state.method === true) {
            sumAllocated = amt
        } else {
            sumAllocated = (amt / 100) * sumPrints
        }

        if (sumAllocated <= sumPrints) {
            this.setState({ sumAllocated: Number(sumAllocated) })
        } else {
            this.setState({ sumAllocated: 0 })
        }
        locBtndisable = true
    }
    getCountry = (countryid: any) => {
        const {
            countries,
        } = this.props
        let myCountry = countries.data.find(e => e.id === countryid)
        return myCountry.name
    }

    moveBack = () => {
        const {
            values,
        } = this.props
        this.props.history.push(`/quote/${values.quoteId}/step03`)
    }

    render() {
        const {
            handleSubmit,
            values,
            quote,
        } = this.props
        let sumPrints: any = this._calculateSum(values.agreedItems, values.unspecifiedItems)
        let myCurrency: any = currency(sumPrints)
        let sumAllocated = this.state.sumAllocated
        let total = sumPrints - sumAllocated
        let atLeastOneItem = (
            total === 0
        ) ? false : true

        if (quote.step04c.done && !this.props.editQuote) {
            this.props.history.push('/quote/' + this.props.match.params.id + '/step05')
        }
        if (values.riskLocations && values.riskLocations.length) {
            Object.values(values.riskLocations).map((al: any, index) => {
                if (this.state.method === true) {
                    al.allocated = Number(this.state.allocated[index]).toFixed(2)
                } else {
                    al.allocated = Number((this.state.allocated[index] / 100) * (sumPrints)).toFixed(2)
                }
            })
        }

        if (this.props.checkStep03update && values.riskLocations.length === 1) {
            sumAllocated = sumPrints
        }

        if (this.props.updateDirty) {
            this.props.dirty ? this.props.updateDirty(true) : this.props.updateDirty(false)
        }

        return (
            <div className="step04 step04c">
                <form className="step04Form quote__form" onSubmit={handleSubmit}>
                    <h5 className="pad0">
                        Although the Collections Policy provides the client worldwide cover
                         we have a requirement to capture risk aggregation data as
                         well as apply relevant insurance tax. Please apportion the
                          collection value to risk locations.
                          </h5>
                    {(values.riskLocations.length > 1) ? (

                        <div className="subjectivity">
                            <div className="subjectivity__title">
                                <span>
                                    Asset location or value has been updated.
                                    Please confirm distribution of the collection
                                </span>
                            </div>
                        </div>

                    ) : null}
                    <div
                        className={`collection_location 
                        ${values.riskLocations.length > 1 ? `margin_t_80` : ``} `}
                    >
                        <div className="collection_location--title">
                            Total value collection
                             <span>{myCurrency}</span>
                        </div>
                        <div className="collection_location--row">
                            <div className="collection_location--row__col total_allocated">
                                Total allocated:
                                <span>{currency(sumAllocated)}</span>
                            </div>
                            <div className="collection_location--row__col total_remaining">
                                Total remaining:
                                <span>{currency(parseFloat(sumPrints) - sumAllocated)}</span>
                            </div>
                            <div className="collection_location--row__col">
                                <ReactSwitch changeMethod={this.changeMethod} />
                            </div>
                        </div>
                    </div>
                    {values.riskLocations && values.riskLocations.length ?
                        <div className="collection_grids">
                            {values.riskLocations.map((location, index) => {
                                return (
                                    <div className="collection_grids--grid" key={location.id}>
                                        <div className="collection_grids--grid__outer">
                                            <div className="collection_grids--grid__left">
                                                <div className="collection_grids--grid__left__title">
                                                    <MarkerIcon color={'#F07662'} width={'13px'} height={'20px'} />
                                                    <h5>
                                                        {location.city}
                                                        {location.postcode ? ', ' + location.postcode : ''}
                                                    </h5>
                                                    {(this.props.mta) ?
                                                        <p>
                                                            {(location.addressLine1) ?
                                                                location.addressLine1 : location.museum}
                                                            {location.addressLine2 ? ', ' + location.addressLine2 :
                                                                ',' + this.getCountry(location.countryId)}
                                                            {location.postcode ? ', ' + location.postcode : ''}
                                                            {location.city ? ', ' + location.city : ''}
                                                            {location.countryName ? ',' + location.countryName : ''}
                                                        </p> :
                                                        <p>
                                                            {location.addressLine1}
                                                            {location.addressLine2 ? ', ' + location.addressLine2 : ''}
                                                            {location.postcode ? ', ' + location.postcode : ''}
                                                            {location.city ? ', ' + location.city : ''}
                                                            {location.countryName ? ',' + location.countryName : ''}
                                                        </p>
                                                    }

                                                </div>
                                            </div><div className="collection_grids--grid__right">
                                                <div className="quote__form__group form__w100 pad0">
                                                    <div className="input">
                                                        <div className="input__pound">
                                                            {this.state.method ? symbol() : '%'}
                                                        </div>
                                                        <input
                                                            type="number"
                                                            name="value"
                                                            placeholder="0"
                                                            step="any"
                                                            min="0"
                                                            max={sumPrints}
                                                            onChange={(event) => {
                                                                this.handleDynamicValueChange(
                                                                    location.id, values.riskLocations, sumPrints, event
                                                                )
                                                            }}
                                                            value={
                                                                this.state.allocated[index] ?
                                                                    this.state.allocated[index] : ''}
                                                            disabled={this.state.al_disable}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> : null
                    }
                    {this.props.editQuote && !atLeastOneItem && locBtndisable ? (
                        <div className="quote__form__group quote__form__group--update">
                            <Button
                                type="submit"
                            >
                                Update
                            </Button>
                        </div>
                    ) : null}
                    <div className="quote__form__group quote__form__group--submit collector-submit-wrapper">
                        <Button
                            half={true}
                            type="button"
                            onClick={this.moveBack}
                        >
                            Back
                        </Button>
                        <Button
                            type="submit"
                            half={true}
                            onClick={() => window.scrollTo(0, 0)}
                            disabled={atLeastOneItem}
                        >
                            Save and continue
                        </Button>
                    </div>
                </form>
            </div>
        )
    }
}
const Step04cForm = withFormik<any, any>({
    enableReinitialize: true,
    mapPropsToValues: (props: any) => {
        return {
            agreedItems: (props.checkStep03update) ?
                get(props, 'quote.step03.response.quote.stockBusinessAssets.agreedItems', {}) :
                get(props, 'fullQuote.stockBusinessAssets.agreedItems', {}),
            unspecifiedItems: (props.checkStep03update) ?
                get(props, 'quote.step03.response.quote.stockBusinessAssets.unspecifiedItems', {}) :
                get(props, 'fullQuote.stockBusinessAssets.unspecifiedItems', {}),
            riskLocations: get(props, 'riskLocations.response', []),
            quoteId: get(props, 'fullQuote.id', ''),
        }
    },
    handleSubmit: (values, { props, setSubmitting, resetForm }) => {
        let cl: any = []

        values.riskLocations.map((el) => {
            let cltemp = {
                'id': el.id,
                'allocated': Number(el.allocated).toFixed(2),
            }
            cl.push(cltemp)
        })
        let content = {
            'quote': {
                'id': props.editRenewal ? props.renewalQuoteId : props.match.params.id,
                'collections_locations': cl,
            },
        }
        if (props.mta) {
            locBtndisable = false
            props.updateData(content)
        } else {
            if (props.editRenewal) {
                locBtndisable = false
                props.setStep04c(content).finally(() => {
                    props.getRenewalVariation(props.renewalQuoteId)
                })
            } else {
                props.setStep04c(content)
                resetForm(content)
            }
        }
        // if (!props.mta) {
        //     resetForm(content)
        // }
        if (props.editQuote) {
            setTimeout(props.update, 500)
        }
    },
})(Step04cFormHTML)

export default Step04cForm


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/EditRenewals/components/Step04c.tsx